
import { defineComponent, PropType } from 'vue'
import { IssueFilterChoice, IssueTypeOptions } from '~/types/issues'
import { getIssueTypeIcon } from '~/utils/ui'

export default defineComponent({
  name: 'IssueCategoryFilter',

  props: {
    selectedCategory: {
      type: String as PropType<IssueTypeOptions>,
      default: ''
    },
    direction: {
      type: String as PropType<'left' | 'right'>,
      default: 'right'
    }
  },

  emits: ['updateCategory', 'reset', 'menu-toggle'],

  data() {
    return {
      categoryLabelMap: {
        [IssueTypeOptions.SECRETS]: 'Secrets',
        [IssueTypeOptions.BUG_RISK]: 'Bug risk',
        [IssueTypeOptions.ANTI_PATTERN]: 'Anti-pattern',
        [IssueTypeOptions.PERFORMANCE]: 'Performance',
        [IssueTypeOptions.SECURITY]: 'Security',
        [IssueTypeOptions.COVERAGE]: 'Coverage',
        [IssueTypeOptions.TYPECHECK]: 'Type check',
        [IssueTypeOptions.STYLE]: 'Style',
        [IssueTypeOptions.DOCUMENTATION]: 'Documentation'
      } as Record<IssueTypeOptions, string>
    }
  },

  computed: {
    filterApplied(): boolean {
      return Boolean(this.selectedCategory)
    },

    appliedFilter(): IssueFilterChoice | null {
      return (
        this.issueCategoryOptions.find(({ shortcode }) => shortcode === this.selectedCategory) ??
        null
      )
    },

    issueCategoryOptions(): IssueFilterChoice[] {
      return (Object.keys(this.categoryLabelMap) as IssueTypeOptions[]).map((categoryKey) => ({
        name: this.categoryLabelMap[categoryKey],
        shortcode: categoryKey,
        icon: categoryKey
      }))
    }
  },

  methods: {
    getIcon: getIssueTypeIcon,

    computedClasses(isOpen: boolean): string {
      if (this.appliedFilter) {
        return 'bg-ink-200 hover:bg-ink-100'
      }

      if (isOpen) {
        return 'border-dashed bg-ink-200 text-vanilla-100'
      }

      return 'border-dashed text-vanilla-400 hover:text-vanilla-100'
    }
  }
})
